import { Checkbox, Flex, Text, Tooltip } from "@instructure/ui";
import { useTranslation } from "react-i18next";

const CopyCourseToggle = ({
  section,
  effectiveState,
  selfState,
  lockedByOther,
  loading,
  onToggle,
}) => {
  const { t } = useTranslation();

  const isDisabled = loading || (lockedByOther && !selfState);

  const handleChange = () => {
    onToggle(section, !selfState);
  };

  const tooltipContent = lockedByOther
    ? selfState
      ? `${t("copyCourse.toggleDescription")}\n\n${t("copyCourse.alsoByCoteacher")}`
      : `${t("copyCourse.toggleDescription")}\n\n${t("copyCourse.setByCoteacher")}`
    : t("copyCourse.toggleDescription");

  return (
    <Tooltip
      renderTip={
        <div style={{ maxWidth: "14rem", whiteSpace: "pre-line" }}>
          {tooltipContent}
        </div>
      }
      placement="bottom start"
    >
      <Checkbox
        label={
          <Flex wrap="wrap" gap="xx-small">
            <Flex.Item>
              <Text size="small" weight="bold">
                {t("copyCourse.toggleLabel")}
              </Text>
            </Flex.Item>
            {lockedByOther && (
              <Flex.Item>
                <Text size="x-small" color="secondary">
                  (
                  {selfState
                    ? t("copyCourse.alsoByCoteacher")
                    : t("copyCourse.setByCoteacher")}
                  )
                </Text>
              </Flex.Item>
            )}
          </Flex>
        }
        variant="toggle"
        size="small"
        checked={effectiveState}
        disabled={isDisabled}
        onChange={handleChange}
      />
    </Tooltip>
  );
};

export default CopyCourseToggle;
